import {LoadingDialog} from "../../../../components/DialogLoading";
import {TwoButtonDialog} from "../../../../designSystem/components/TwoButtonDialog";
import React from "react";

export enum LOGIN_MODAL_CONTENT {
  LOADING = 'loading',
  ERROR = 'error'
}

export const LoginModalContent = ({
  handleCloseDialog
}) => ({
  [LOGIN_MODAL_CONTENT.LOADING]: (
    <LoadingDialog label="載入中" />
  ),
  [LOGIN_MODAL_CONTENT.ERROR]: (
    <TwoButtonDialog
      type="warning"
      title="登入失敗，請再試一次"
      leftLabel="了解"
      leftOnClick={handleCloseDialog}
      leftIconName="fa-check"
    />
  )
})